import React from "react";

interface ProjectCardProps {
  title: string;
  image?: string;
  description: string;
  tags: string[];
  onClick: () => void;
}

const ProjectCard = ({ title, image, description, tags, onClick }: ProjectCardProps) => (
  <div
    className="bg-white shadow-xl rounded-xl p-4 cursor-pointer transition-all duration-500 w-full max-w-md border-l-4 border-blue-400"
    onClick={onClick}
  >
    {image && (
      <img
        src={image}
        alt={`${title} thumbnail`}
        className="w-full h-auto object-contain rounded-md mb-4"
      />
    )}
    <h3 className="text-xl font-bold mb-2">{title}</h3>
    <p className="text-gray-600 mb-4">{description}</p>
    <div className="flex flex-wrap gap-2">
      {tags.map((tag, index) => (
        <span
          key={index}
          className="bg-blue-500 text-white text-sm px-3 py-1 rounded-full"
        >
          {tag}
        </span>
      ))}
    </div>
  </div>
);

export default ProjectCard;
